import css from './AddressInputTable.css'
import { on, ready, query, queryAll } from '../../lib/dom.js'
import { hide, show, fireEvent, ajaxPost } from '../../lib/jsfunc.js'

ready(function() {
  if(!query('.AddressInputTable')) return;

  var country = query('select.billingCountry').options[query('select.billingCountry').selectedIndex].value;
  var tables = queryAll('.AddressInputTable');
  [].forEach.call(tables, function(table) {
    [].forEach.call(queryAll(table, 'select'), function(select) {
      if(country == 'US'){
        if(!select.classList.contains('billingState') && !select.classList.contains('billingCountry')&&!select.classList.contains('deliveryState') && !select.classList.contains('deliveryState'))
          fireEvent(select, 'change');
      }else{
        fireEvent(select, 'change');
      }
    });
  });

  
  var billingState = query('select.billingState');
  if(billingState){
    updateStateOptions('select.billingState', 'select.billingCountry');
    fireEvent(billingState, 'change');
    
    on('change', 'select.billingState', function(event) {
      var select = event.target;
      var state = select.options[select.selectedIndex].value;
      var val = event.target.value;
      if( val.length > 0 ){
        hide('span.billingState.selecterror');
      }else{
        show('span.billingState.selecterror');
      }
      
      if( state == 'US-MA'){
        show('tr > td.VatNr');
        show('.VatNr span.error');
      }else{
        hide('tr > td.VatNr');
        hide('.VatNr span.error');
      }
    })
  }
 
  var deliveryState = query('select.deliveryState');
  if(deliveryState){
    updateStateOptions('select.deliveryState', 'select.deliveryCountry');
    fireEvent(deliveryState, 'change');
    on('change', 'select.deliveryState', function(event) {
      var select = event.target;
      var state = select.options[select.selectedIndex].value;

      var val = event.target.value;
      if( val.length > 0 ){
        hide('span.deliveryState.selecterror');
      }else{
        show('span.deliveryState.selecterror');
      }
    })
  }
  
  var vatnr = query('.VatNr');
  if(vatnr && vatnr.style.visibility == 'visible'){
    var val = query('input.billingVatNr').value;
    if( val.length > 0 ){
      hide('.VatNr span.error');
    }else{
      show('span.checkTENO');
    }
  }
})

  on('change', '.AddressInputTable select', function(event){
    var select = event.target;
    if(select.options[select.selectedIndex].matches('.default'))
      select.classList.add('default');
    else 
      select.classList.remove('default');
    
  })
  on('change', '.AddressInputTable.billingAddress tr.comment textarea', function(event) {
    var table = query('.AddressInputTable.billingAddress');
    var sendrequest = table.getAttribute('data-sendrequest');
    var inrequest = table.getAttribute('data-inrequest');
    if(sendrequest){
      table.setAttribute('data-inrequest', true);
      table.setAttribute('data-sendrequest', false);

      ajaxPost(
        event.target.getAttribute('data-url'), {
          'bemerkung' : query(table, 'tr.comment textarea').value
        }
      );
      table.setAttribute('data-inrequest', false);
      table.setAttribute('data-sendrequest', true);
    }
  })
  
  on('change', '.AddressInputTable.billingAddress tr.reference input', function(event) {
    var table = query('.AddressInputTable.billingAddress');
    var sendrequest = table.getAttribute('data-sendrequest');
    var inrequest = table.getAttribute('data-inrequest');
    if(sendrequest){
      table.setAttribute('data-inrequest', true);
      table.setAttribute('data-sendrequest', false);
      
      ajaxPost(
        event.target.getAttribute('data-url'), {
          'referenz' : query(table, 'tr.reference input').value
        }
      );
      table.setAttribute('data-inrequest', false);
      table.setAttribute('data-sendrequest', true);
    }
  })

  on('change', '.AddressInputTable input.checkDeliveryAddress', function(event) {
    event.preventDefault();
    if(event.target.checked){
      hide('.AddressInputTable.deliveryAddress');
    }else{
      show('.AddressInputTable.deliveryAddress');
    }
  })

  on('change', 'select.billingAnrede', function(event) {
    var val = event.target.value;
    if( val.length > 0 ){
      hide('span.billingAnrede.selecterror');
    }else{
      show('span.billingAnrede.selecterror');
    }
  })

  on('change', 'select.deliveryAnrede', function(event) {
    var val = event.target.value;
    if( val.length > 0 ){
      hide('span.deliveryAnrede.selecterror');
    }else{
      show('span.deliveryAnrede.selecterror');
    }
  })

  on('change', 'input.billingCompany', function(event) {
    var val = event.target.value;
    if( val.length > 0 ){
      hide('span.billingCompany.error');
    }else{
      show('span.billingCompany.error');
    }
  })

  on('change', 'input.deliveryCompany', function(event) {
    var val = event.target.value;
    if( val.length > 0 ){
      hide('span.deliveryCompany.error');
    }else{
      show('span.deliveryCompany.error');
    }
  })

  on('change', 'input.billingVatNr', function(event) {
    var val = event.target.value;
    if( val.length > 0 ){
      hide('.VatNr span.error');
    }else{
      show('.VatNr span.error');
    }
  })

  on('change', 'select.billingCountry', function(event) {
    var select = event.target;
    var country = select.options[select.selectedIndex].value;
    var selected = query(select, 'option:checked');
    if(selected){
      var euland = selected.getAttribute('data-euland') == 1 ? true : false;
    }else{
      euland = false;
    }

    if( euland && country != 'DE'){
      show('td.VatNr');
      show('.VatNr span.error');
    }else{
      hide('td.VatNr');
      hide('.VatNr span.error');
    }
    var val = event.target.value;
    if( val.length > 0 ){
      hide('span.billingCountry.selecterror');
    }else{
      show('span.billingCountry.selecterror');
    }
    updateStateOptions('select.billingState', event.target);
    selectFirstStateOption('select.billingState');
  })

  on('change', 'select.deliveryCountry', function(event) {
    var select = event.target;
    var country = select.options[select.selectedIndex].value;
    var selected = query(select, 'option:checked');
    if(selected){
      var euland = selected.getAttribute('data-euland') == 1 ? true : false;
    }else{
      euland = false;
    }
    if( euland && country != 'DE'){
      show('td.VatNr');
      show('.VatNr span.error');
    }else{
      if(!query('.AddressInputTable input.checkDeliveryAddress').checked && country != ''){
        hide('td.VatNr');
        hide('.VatNr span.error');
      }
    }
    var val = event.target.value;
    if( val.length > 0 ){
      hide('span.deliveryCountry.selecterror');
    }else{
      show('span.deliveryCountry.selecterror');
    }

    updateStateOptions('select.deliveryState', event.target);
    selectFirstStateOption('select.deliveryState');

    var val = event.target.value;
    if( val.length > 0 ){
      hide('span.deliveryCountry.selecterror');
    }else{
      show('span.deliveryCountry.selecterror');
    }
  })
  
  on('change', '.application-contact .AddressInputTable input.error', function(event) {
    event.preventDefault();
    if(event.target.value != '') event.target.classList.remove('error');
  })
  
  on('change', '.AddressInputTable select', function(event){
    var td = event.target.closest('td');

    if(td){
      if(query(td, '.selecterror') && event.target.value.length>0){
        //hide(query(td, '.selecterror'));
      }
    }
  })


function updateStateOptions(state_sel, country_sel) {
  if(typeof country_sel == 'string'){
    var country = query(country_sel);
  }else var country = country_sel;

  if(!country){
    return;
  }

  var state = query(state_sel);
  if(!state){
    return;
  }

  var states = query(country, 'option[value="'+country.value+'"]').getAttribute('data-states');
  var stateSelected = query(country, 'option[value="'+country.value+'"]').getAttribute('data-state-sel');

  // remove all but first option
  state.options.length = 1;

  var JSONObj = JSON.parse(states);
  for( var key in JSONObj ) {
    var name = JSONObj[key];
    var opt = document.createElement("OPTION");
    opt.value = key;
    opt.setAttribute('data-land', country.value);
    opt.text = name;
    if(key == stateSelected){
      opt.selected = true;
      state.appendChild(opt);
    }
    state.appendChild(opt);
  }
}

function selectFirstStateOption(state_sel) {
  var state = query(state_sel);
  if(!state){
    return;
  }

  var valIs = state.value;
  var valShould = query(state, 'option:not(.hidden)').value;

  if (valIs != valShould) {
    state.value = valShould;
    fireEvent(state, 'change');
  }
}
